import { useEffect, useState, useMemo } from 'react';
import { s } from './CourtInformation.styles';
import LoanInfoService from '../../../service/LoanInfo';
import Loading from '../../../func/components/loading/LoadingCircle';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { BasicInfo } from './data';
import Footer from '../../components/footer/Footer';
const exportIcon = '/assets/images/icon/Icon_Export_gray.svg'
const arrowIcon = '/assets/images/icon/Arrow.svg'
const arrowBottomIcon = '/assets/images/arrow/arrow_down.svg'
const DocumentDeliveryDetails = () => {
  const [basicInfo, setBasicInfo] = useState<BasicInfo>();
  const [documentProcessing, setDocumentProcessing] = useState<any[]>([]);
  const [documentDelivery, setDocumentDelivery] = useState<any[]>([]);
  const [caseNo, setCaseNo] = useState<string>();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // iidx 추출 및 캐싱
  const iidx = useMemo(() => {
    const param = new URLSearchParams(window.location.search).get('iidx');
    return param ? Number(param) : null;
  }, []);

  useEffect(() => {
    if (!iidx) return;
    fetchAll(iidx);
  }, [iidx]);

  const fetchAll = async (iidx: number) => {
    setLoading(true);
    try {
      await Promise.all([
        fetchCaseNo(iidx),
        fetchDeliveryData(iidx)
      ]);
    } catch (error) {
      console.error('❌ 데이터 전체 로딩 실패:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCaseNo = async (iidx: number) => {
    try {
      const res = await LoanInfoService.courtDetail(iidx);
      const caseNo = res?.data?.case_detail?.basic_info?.case_no;
      if (caseNo) setCaseNo(caseNo);
    } catch (e) {
      console.error('❌ 사건번호 불러오기 실패:', e);
    }
  };

  const fetchDeliveryData = async (iidx: number) => {
    try {
      const res = await LoanInfoService.documentDelivery(iidx);
      setBasicInfo(res?.data?.item_detail?.basic_info);
      setDocumentProcessing(res?.data?.date_list ?? []);
      setDocumentDelivery(res?.data?.date_list2 ?? []);
    } catch (e) {
      console.error('❌ 송달내역 불러오기 실패:', e);
    }
  };

  useEffect(() => {
  window.scrollTo(0, 0);
  }, [iidx]);
  
  return (
    <s.Container>
      {loading && <Loading />}
      {!loading && (
        <s.Inner>
          <TitleWrapper>
            <PageTitleBox>
              <div style={{display:'flex', alignItems: 'center', gap:'6px', letterSpacing:'-0.36px'}}>
                <BackButton onClick={() => window.close()}>
                  <img src={arrowIcon} alt="" />
                </BackButton>
               <div>
                {caseNo ? (
                  <div>{caseNo} 문건/송달내역</div>
                ) : (
                  <div>로딩 중...</div>
                )}
              </div>
              </div>
              <IconWrapper>
                <img src={exportIcon} alt="" style={{ width: '24px', height: '24px' }}/>
              </IconWrapper>
              </PageTitleBox>
          </TitleWrapper>
          <s.Content style={{ padding: '32px 16px 16px' }}>
            <DuplicationWrapper>
              <DuplicationTitle>중복/병합사건</DuplicationTitle>
              <DuplicationBox>{caseNo}<img src={arrowBottomIcon} style={{ position: 'absolute', right: '12px' }}/></DuplicationBox>
            </DuplicationWrapper>
            <s.ContentTitleBox style={{ padding:'24px 0 24px' }}>문건처리내역</s.ContentTitleBox>
            <TableScrollWrapper style={{ width: '100%' }}>
            <s.Table style={{ minWidth: '412px', width: 'fit-content' }}>
              <thead>
                <s.Row>
                  <s.TableHeadTh width="110px">접수일</s.TableHeadTh>
                  <s.TableHeadTh width="220px">접수내역</s.TableHeadTh>
                  <s.TableHeadTh width="80px">결과</s.TableHeadTh>
                </s.Row>
              </thead>
              <tbody>
                {documentProcessing.map((item, index) => (
                  <s.Row key={index}>
                    <s.ContentCell
                      width="110px"
                      border={true}
                      textAlign="center"
                      style={{ borderRight: '1px solid #e1e2e4' }}
                    >
                      {item[0] === '' ? '-' : item[0]}
                    </s.ContentCell>
                    <s.ContentCell
                      width="220px"
                      border={true}
                      textAlign="left"
                      style={{ borderRight: '1px solid #e1e2e4' }}>
                      {item[1] === '' ? '-' : item[1]}
                    </s.ContentCell>
                    <s.ContentCell
                      width="80px"
                      border={true}
                      textAlign="center"
                    >
                      {item[2] === '' ? '-' : item[2]}
                    </s.ContentCell>
                  </s.Row>
                ))}
              </tbody>
              </s.Table>
             </TableScrollWrapper>
          </s.Content>
          <s.Content style={{ padding: '16px' }}>
            <s.ContentTitleBox style={{ padding:'0 0 24px' }}>송달내역</s.ContentTitleBox>
            <TableScrollWrapper style={{ width: '100%', marginBottom: '40px' }}>
            <s.Table style={{ minWidth: '442px', width: 'fit-content' }}>
              <thead>
                <s.Row>
                  <s.TableHeadTh width="110px">송달일</s.TableHeadTh>
                  <s.TableHeadTh width="220px">송달내역</s.TableHeadTh>
                  <s.TableHeadTh width="80px">송달결과</s.TableHeadTh>
                </s.Row>
              </thead>
              <tbody>
                {documentDelivery.map((item, index) => (
                  <s.Row key={index}>
                    <s.ContentCell
                      width="110px"
                      border={true}
                      textAlign="center"
                      style={{ borderRight: '1px solid #e1e2e4' }}
                    >
                      {item[0] === '' ? '-' : item[0]}
                    </s.ContentCell>
                    <s.ContentCell
                      width="220px"
                      border={true}
                      textAlign="left"
                      style={{ borderRight: '1px solid #e1e2e4' }}>
                      {item[1] === '' ? '-' : item[1]}
                    </s.ContentCell>
                    <s.ContentCell
                      width="80px"
                      border={true}
                      textAlign="center"
                    >
                      {item[2] === '' ? '-' : item[2]}
                    </s.ContentCell>
                  </s.Row>
                ))}
              </tbody>
            </s.Table>
           </TableScrollWrapper>
          </s.Content>
        </s.Inner>
      )}
       <Footer/>
    </s.Container>
  );
};

export default DocumentDeliveryDetails;

const TitleWrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid #70737C29;
`

const PageTitleBox = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
`

const BackButton = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const IconWrapper  = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const DuplicationWrapper = styled.div`
  border: 1px solid #E1E2E4;
  padding: 16px;
  border-radius: 8px;
`
const DuplicationTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  line-height: 145%;
  border-radius: 8px;
  margin-bottom: 4px;
`

const DuplicationBox = styled.div`
  background: #F7F8FC;
  border-radius: 8px;
  padding: 10px 12px;
  position: relative;
  height: 40px;
  color: #616161;
  font-size: 14px;
  font-weight: 500;
`

const TableScrollWrapper = styled.div`
  overflow-x: auto;
  padding-bottom: 24px; 
  width: 100%;

 /* 스크롤바 디자인 */
  &::-webkit-scrollbar {
    height: 8px;
    background-color: #000;
  }

  &::-webkit-scrollbar-track {
     
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #999;
  }

  /* 화살표 숨기기 */
  &::-webkit-scrollbar-button {
    display: none;
    height: 0;
    width: 0;
  }
  scrollbar-color: #C1C1C1 #F0F0F0; /* Firefox */
  scrollbar-width: thin;
`;